module.exports = __webpack_public_path__ + "static/photo7-808ce86f15b3b35d2422b0804411ed93.jpg";